import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "postTypeContainer", "imageSection", "fileInput",
    "captionInput", "captionCount",
    "uploadArea", "existingImagePreview", "newImagePreview", "previewImg",
    "previewCaption", "previewImageContainer", "previewImage",
    "timingRadio", "scheduleFields", "scheduledAtInput", "scheduleButton", "publishNowButton", "timingHint"
  ]

  connect() {
    this.updatePostTypeUI()
    this.updateCaptionCount()
    this.updatePreview()
    // 編集画面・422 再描画でもサーバ側の初期選択を JS 側の状態と揃える
    this.updateTimingUI()
    this.updateButtons()
  }

  changePostType() {
    this.updatePostTypeUI()
  }

  updatePostTypeUI() {
    const selectedType = this.element.querySelector('input[name*="post_type"]:checked')?.value
    if (this.hasImageSectionTarget) {
      this.imageSectionTarget.style.display = selectedType === "image" ? "" : "none"
    }
  }

  updateCaptionCount() {
    if (this.hasCaptionInputTarget && this.hasCaptionCountTarget) {
      this.captionCountTarget.textContent = this.captionInputTarget.value.length
    }
  }

  previewImage(event) {
    const file = event.target.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      if (this.hasPreviewImgTarget) {
        this.previewImgTarget.src = e.target.result
        this.newImagePreviewTarget.classList.remove("hidden")
        if (this.hasUploadAreaTarget) {
          this.uploadAreaTarget.classList.add("hidden")
        }
        if (this.hasExistingImagePreviewTarget) {
          this.existingImagePreviewTarget.classList.add("hidden")
        }
      }
      // Update right-side preview
      if (this.hasPreviewImageTarget) {
        this.previewImageTarget.src = e.target.result
        this.previewImageContainerTarget.classList.remove("hidden")
      }
    }
    reader.readAsDataURL(file)
  }

  removeImage() {
    if (this.hasFileInputTarget) {
      this.fileInputTarget.value = ""
    }
    if (this.hasNewImagePreviewTarget) {
      this.newImagePreviewTarget.classList.add("hidden")
    }
    if (this.hasUploadAreaTarget) {
      this.uploadAreaTarget.classList.remove("hidden")
    }
    if (this.hasPreviewImageContainerTarget) {
      this.previewImageContainerTarget.classList.add("hidden")
    }
  }

  updatePreview() {
    if (this.hasCaptionInputTarget && this.hasPreviewCaptionTarget) {
      const text = this.captionInputTarget.value.trim()
      if (text) {
        this.previewCaptionTarget.innerHTML = ""
        this.previewCaptionTarget.textContent = text
      } else {
        this.previewCaptionTarget.innerHTML = '<span class="text-gray-400">投稿内容を入力...</span>'
      }
    }
  }

  // ---- 公開のタイミング ----

  // timing はフォーム専用のラジオ(モデル属性ではない)。押されたボタンの commit_action で処理が決まる
  get isSchedule() {
    const checked = this.timingRadioTargets.find((radio) => radio.checked)
    return checked ? checked.value === "schedule" : false
  }

  changeTiming() {
    this.updateTimingUI()
    this.updateButtons()
  }

  updateTimingUI() {
    if (!this.hasScheduledAtInputTarget) return

    const isSchedule = this.isSchedule
    if (this.hasScheduleFieldsTarget) this.scheduleFieldsTarget.classList.toggle("hidden", !isSchedule)
    // 「今すぐ」のときは disabled にして送信対象から外す(隠れた予約日時をサーバに送らない)
    this.scheduledAtInputTarget.disabled = !isSchedule
  }

  updateButtons() {
    if (!this.hasScheduledAtInputTarget) return

    const isSchedule = this.isSchedule
    // 「今すぐ」のとき日時欄は disabled だが value は読めるので、判定は予約時だけ使う
    const hasSchedule = this.scheduledAtInputTarget.value !== ""

    if (this.hasScheduleButtonTarget) this.scheduleButtonTarget.disabled = !(isSchedule && hasSchedule)
    if (this.hasPublishNowButtonTarget) this.publishNowButtonTarget.disabled = isSchedule

    // ボタンが押せない理由をその場で伝える(活性なら出さない)
    if (this.hasTimingHintTarget) {
      const reason = isSchedule && !hasSchedule ? "予約するには日時を入力してください" : null
      this.timingHintTarget.textContent = reason || ""
      this.timingHintTarget.classList.toggle("hidden", reason === null)
    }
  }
}
